import React from 'react';
import {browserHistory} from 'react-router';
import PropTypes from 'prop-types';
import * as immutable from 'immutable';
import './TopicFormTriggerUsage.styl';
import BulletedRuleDescription from 'components/triggers/BulletedRuleDescription';
import GenericLink from 'components/GenericLink';

/**
 * Displays a list of triggers that use a topic, with links to each trigger.
 */
export default class TopicFormTriggerUsage extends React.PureComponent {
  static propTypes = {
    triggers: PropTypes.instanceOf(immutable.List).isRequired,
  };

  render() {
    const {triggers} = this.props;
    return (
      <div className="topic-form-trigger-usage">
        {triggers.size === 0 && <p>Not used in any Smart Alerts.</p>}
        {triggers.map(trigger => (
          <div key={trigger.id} className="topic-form-trigger-usage-link">
            <div onClick={() => browserHistory.push(`/admin/actions/${trigger.id}`)}>
              <BulletedRuleDescription text={trigger.name} />
              <footer>
                <GenericLink onClick={() => browserHistory.push(`/admin/actions/${trigger.id}`)}>
                  View/Edit
                </GenericLink>
              </footer>
            </div>
          </div>
        ))}
      </div>
    );
  }
}
